import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';
import { getAlertProperties } from './utils';

export const createAlertsEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackAlertsDropdownOpen = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.ALERTS_DROPDOWN_OPEN,
      properties: { source },
    });

  const trackAlertsPageOpen = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.ALERTS_PAGE_OPEN,
      properties: { source },
    });

  const trackAlertsMarkAllAsRead = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.ALERTS_MARK_ALL_AS_READ,
      properties: { source },
    });

  const trackAlertTracked = (
    source: PosthogTrackingSource,
    alertData: {
      id: string;
      source_id: string;
      source_type: string;
      created_at: string;
    }
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.ALERT_TRACKED,
      properties: { source, ...getAlertProperties(alertData) },
    });

  const trackAlertUntracked = (
    source: PosthogTrackingSource,
    alertData: {
      id: string;
      source_id: string;
      source_type: string;
      created_at: string;
    }
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.ALERT_UNTRACKED,
      properties: { source, ...getAlertProperties(alertData) },
    });

  return {
    getAlertProperties,
    trackAlertsDropdownOpen,
    trackAlertsPageOpen,
    trackAlertsMarkAllAsRead,
    trackAlertTracked,
    trackAlertUntracked,
  };
};
